export default {
  apiKey: "AIzaSyCSRE5cJNbU6z_ArehRCV69oZj2ztfbFl0",
  authDomain: "brouwhulp-15111.firebaseapp.com",
  databaseURL: "https://brouwhulp-15111.firebaseio.com",
  projectId: "brouwhulp-15111",
  storageBucket: "brouwhulp-15111.appspot.com",
  messagingSenderId: "909029654560",
  appId: "1:909029654560:web:9db2f65d7ad4fea3fd7c45",
};
